// extracted by mini-css-extract-plugin
export default {"root":"RenameListModal_root__W9x4l","title":"RenameListModal_title__NwGK+"};